import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  colors,
  Container,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Snackbar,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";
import API from "../../../network/dashboardAPI";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TablePagination,
} from "@material-ui/core";
import {
  Label,
  ListAlt,
  PermContactCalendar,
  ShoppingBasket,
  ShoppingCart,
} from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const RecentSearchAndPopular = () => {
  /**
   */
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [keywordId, setKeywordId] = useState(null);
  const [list, setList] = useState([]);
  const [type, setType] = useState("");
  const [search, setSearch] = useState("");
  const [keyword, setKeyword] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [openDialogSequence, setOpenDialogSequence] = useState(false);
  const [draggedItem, setDraggedItem] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [state, setState] = React.useState({
    openSnacker: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal, openSnacker } = state;

  const handleClick = (newState) => {
    setState({ openSnacker: true, ...newState });
  };

  const handleClose = () => {
    setState({ ...state, openSnacker: false });
  };

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const reset = () => {
    setKeywordId(null);
    setKeyword("");
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value));
  };

  const handleClickSetup = (type, data = null) => {
    setOpen(!open);
    switch (type) {
      case "update": {
        setType("Update");
        setKeywordId(data.id);
        setKeyword(data.keyword);
        break;
      }
      default: {
        reset();
        setType("Create");
        break;
      }
    }
    setTimeout(() => {}, 800);
  };
  const clodeModal = () => {
    reset();
    setOpen(false);
  };

  const getGlobalSearchKeyword = async () => {
    setLoading(true);
    let body = {
      page: page,
      limit: rowsPerPage,
    };
    await API.getGlobalStoreKeyword(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setList(data.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Global Keyword:", error); // Handle errors
      });
  };

  const createKeyword = async () => {
    setSubmitting(true);
    let body = {
      keyword: keyword,
    };
    if (list.data.length >= 10) {
      alert("Keywords Max Out of Limit");
      return;
    }
    await API.createGlobalStoreKeyword(body)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          if(res.data.success == false){
            alert(res.data.message);
          }
          setSubmitting(false);
          setOpen(false);
          getGlobalSearchKeyword();
        } else {
          setSubmitting(false);
          handleClick({ vertical: "top", horizontal: "center" });
        }
      });
  };

  const deleteToggle = (id) => {
    setKeywordId(id);
    setOpenDelete(!openDelete);
  };

  const handleDelete = async () => {
    await API.deleteGlobalStoreKeyword(keywordId)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setOpenDelete(false);
          getGlobalSearchKeyword();
        } else {
          handleClick({ vertical: "top", horizontal: "center" });
        }
      });
  };
  const updateKeyword = async () => {
    setSubmitting(true);
    let body = {
      keyword: keyword,
      id: keywordId,
    };
    await API.updateGlobalStoreKeyword(body)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          if(res.data.success == false){
            alert(res.data.message);
          }
          setSubmitting(false);
          setOpen(false);
          getGlobalSearchKeyword();
        } else {
          setSubmitting(false);
          handleClick({ vertical: "top", horizontal: "center" });
          // setOpen(false);
        }
      });
  };

  const markActive = async (id, status) => {
    let body = {
      is_active: status,
      id: id,
    };
    await API.enableDisableGlobalStoreKeyword(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          getGlobalSearchKeyword();
        }
      })
      .catch((error) => {
        console.error("Error update:", error); // Handle errors
      });
  };

  const handleDragStart = (e, item) => {
    setDraggedItem(item);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = async (e, droppedItem) => {
    e.preventDefault();
    if (submitting) return;
    if (droppedItem.id === draggedItem.id) return;

    const updatedItems = [...list.data];
    const draggedIndex = updatedItems.findIndex(
      (item) => item.id === draggedItem.id
    );
    const droppedIndex = updatedItems.findIndex(
      (item) => item.id === droppedItem.id
    );
    const [item] = updatedItems.splice(draggedIndex, 1);
    updatedItems.splice(droppedIndex, 0, item);
    let postData = {
      id: item.id,
      order: droppedIndex + 1,
    };
    await API.updateOrderGlobalStoreKeyword(postData);
    setList({ ...list, data: updatedItems });
    setDraggedItem(null);
    getGlobalSearchKeyword();
  };

  useEffect(() => {
    getGlobalSearchKeyword();
  }, [page, rowsPerPage]);

  return (
    <Box component="div" m={1}>
      <Paper className="p-2">
        <Typography className="pl-4 font-bold" variant="h6">
          Popular Search
        </Typography>
        <Grid container spacing={1} className="my-2 pl-4">
          <Grid item sm={3}>
            <Button
              onClick={() => handleClickSetup("create")}
              variant="contained"
              color="primary"
            >
              <AddIcon /> Popular Search
            </Button>
          </Grid>
          {/* <Grid item sm={5}>
            <TextField variant="outlined" label="search" onChange={(e) => handleSearch(e.target.value)}/> 
          </Grid> */}
        </Grid>
        <Container>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Keyword</TableCell>
                  <TableCell>Order</TableCell>
                  <TableCell component="th" align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: "100px" }}
                      >
                        <Grid item>
                          <CircularProgress size={40} color="primary" />
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ) : list?.data?.length ? (
                  list?.data.map((item) => {
                    return (
                      <TableRow
                        key={item.id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, item)}
                        onDragOver={(e) => handleDragOver(e)}
                        onDrop={(e) => handleDrop(e, item)}
                        style={{ cursor: "move" }}
                        hover
                      >
                        <TableCell>{item.id}</TableCell>
                        <TableCell>{item.keyword}</TableCell>
                        <TableCell>{item.order}</TableCell>
                        <TableCell align="center">
                          <div className="display-flex">
                            {item.is_active == 1 ? (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  markActive(item.id, item.is_active ? 0 : 1)
                                }
                              >
                                Active
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={() =>
                                  markActive(item.id, item.is_active ? 0 : 1)
                                }
                              >
                                In Active
                              </Button>
                            )}
                            <IconButton
                              onClick={() => handleClickSetup("update", item)}
                              aria-label="edit"
                            >
                              <EditIcon style={{ color: colors.blue[600] }} />
                            </IconButton>
                            <IconButton
                              onClick={() => deleteToggle(item.id)}
                              aria-label="delete"
                            >
                              <DeleteIcon style={{ color: colors.red[600] }} />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data
                    </TableCell>
                  </TableRow>
                )}
                <TableRow></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={list.total}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[25, 50]}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Container>
      </Paper>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={clodeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{type} Keyword</DialogTitle>
        <DialogContent style={{ minWidth: "500px" }}>
          <Grid container spacing={1}>
            <Grid className="mb-2 p-1" sm={12}>
              <TextField
                fullWidth
                value={keyword}
                variant="outlined"
                placeholder="Keyword"
                onChange={(e) => setKeyword(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={clodeModal} color="secondary">
            Close
          </Button>
          {type == "Create" ? (
            <Button
             disabled={submitting}
              onClick={() => {
                createKeyword();
              }}
              color="primary"
            >
              {type}
            </Button>
          ) : (
            <Button
              disabled={submitting}
              onClick={() => {
                updateKeyword();
              }}
              color="primary"
            >
              {type}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* delete confirm modal */}
      <Dialog
        open={openDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={deleteToggle}
        aria-labelledby="alert-dialog-slide-title2"
        aria-describedby="alert-dialog-slide-description1"
      >
        <DialogTitle id="alert-dialog-slide-title2">
          Delete Confirmation
        </DialogTitle>
        <DialogContent style={{ minWidth: "500px" }}>
          <Typography>Are You Sure To Delete this </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteToggle} color="secondary">
            Close
          </Button>
          <Button
            onClick={() => {
              handleDelete();
            }}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openSnacker}
        onClose={handleClose}
        message="Something went wrong"
        key={vertical + horizontal}
      />
    </Box>
  );
};

export default RecentSearchAndPopular;
